import { useQuery } from '@tanstack/react-query'
import { v1OrganizationsApi } from '../api'

export function useOrganizationUsers(
  orgId: string, 
  page = 1, 
  limit = 10, 
  search?: string
) {
  return useQuery({
    queryKey: ['v1', 'organizations', orgId, 'users', page, limit, search],
    queryFn: () => v1OrganizationsApi.getOrganizationUsers(orgId, page, limit, search),
    enabled: !!orgId
  })
}
